import * as React from "react";

export class HamburgerNavigationActionButton extends React.Component < {
    class : string,
    link : string
}, {} > {
    constructor(props) {
        super(props)
    }

    render() {
        return (
            <a
                href={this.props.link || "javascript:;"}
                className={`rj-hamburger-button rj-hamburger-button-${this.props.class}`}>
                <span
                    className={`rj-hamburger-button-icon i-o-hamburger-${this.props.class} icon`}></span>
            </a>
        )
    }
}